export default "__VITE_ASSET__Cf5tdq93__"